"use strict"
import './components/config'
import './components/animations'
import './components/header'
import './components/data-src'
import './components/slider'
import './components/count'
import './components/clear-form'
import './components/map'
import './components/modal'